import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AdminAppBar from "../adminComponents/AdminAppBar";
import LeadDbService from "../Services/LeadDbService";
import Select from "react-select";
import leadSourceService from "../Services/LeadSourceService";
import AllLeadFilter from "./AllLeadFilter";
import teamService from "../Services/TeamService";
import { getBasePathByUserRole } from "../../utils/roleRoutes";

const UnassignedLead = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedLeadStatusId, setSelectedLeadStatusId] = useState(
    location.state?.statusId || "L0CTrn0qwWlHWvq2gXDm"
  );

  console.log(location.state)


  const [loading, setLoading] = useState(false);
  const [leadSources, setLeadSources] = useState([]);
  const [selectedLeadSource, setSelectedLeadSource] = useState("");
  const [selectedLeadSourceId, setSelectedLeadSourceId] = useState("");
  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedTeamId, setSelectedTeamId] = useState("");
  const [leads, setLeads] = useState([]);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [prevPageToken, setPrevPageToken] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [totalLeads, setTotalLeads] = useState(0);
  const [hasMoreLeads, setHasMoreLeads] = useState(false);
  const [cachedPages, setCachedPages] = useState({});

  const teamStatus = location?.state?.teamStatus;


  const isDisabled = teamStatus ? !selectedLeadSource || !selectedTeamId : !selectedLeadSource;


    const [team, setTeam] = useState([]);
  
  
    const fetchTeamData = async () => {
      setLoading(true);
      try {
        const response = await teamService.getTeamName();
        setTeam(response.data?.teams || []);
        
      } catch (error) {
     
  
        console.error("Error fetching Teams", error);
      } finally {
        setLoading(false);
      }
    };
    useEffect(() => {
      fetchTeamData();
    }, []);

  useEffect(() => {
    const fetchLeadSources = async () => {
      try {
        const response = await leadSourceService.fetchLeadSources();
        setLeadSources(response.data);
      } catch (error) {
        console.error("Error fetching leadSources:", error);
      }
    };
    fetchLeadSources();
  }, []);


  const handleLeadSourceChange = (e) => {
    setSelectedLeadSource(e);
    setSelectedLeadSourceId(e?.value || "");
  };

  const handleTeamChange = (e) => {
    console.log("handle team change " + e?.value )
    setSelectedTeam(e);
    setSelectedTeamId(e?.value || "");
  };

  const handleStatusChange = (status) => {
    setSelectedStatus(status);
    setCurrentPage(1);
    setNextPageToken(null);
    setPrevPageToken(null);
    handleLoadData(null, null);
  };

  const handleLoadData = async (token = null, direction = null) => {
    if (!selectedLeadSourceId && !token) {
      return;
    }

    setLoading(true);

    try {
      const pageNumber = direction === "next" ? currentPage + 1 : direction === "previous" ? currentPage - 1 : 1;

      if (cachedPages[pageNumber] && cachedPages[pageNumber].sourceId === selectedLeadSourceId) {
        setLeads(cachedPages[pageNumber].data);
        setNextPageToken(cachedPages[pageNumber].next || null);
        setPrevPageToken(cachedPages[pageNumber].previous || null);
        setCurrentPage(pageNumber);
        setHasMoreLeads(cachedPages[pageNumber].hasMore);
        setLoading(false);
        return;
      }
      if (!selectedLeadSourceId && !token) {
        setLoading(false);
        return;
      }

      const params = {
        leadSourceId: selectedLeadSourceId,
        team :String(location.state?.teamStatus),
        teamId : selectedTeamId,
        next: direction === "next" ? token : null,
        previous: direction === "previous" ? token : null,
        direction: direction,
      };

      console.log("API params:", params);

      const response = await LeadDbService.getUnassignLead(params);
      const data = Array.isArray(response.data?.leadsArray) ? response.data.leadsArray : [];

      setLeads(data);
      setTotalLeads(response.data?.maxCount || 0);
      setNextPageToken(response.data?.next || null);
      setPrevPageToken(response.data?.previous || null);
      setCurrentPage(pageNumber);

      const hasMore = data.length === 10 && (pageNumber * 10) < response.data?.maxCount;
      setHasMoreLeads(hasMore);

      setCachedPages(prev => ({
        ...prev,
        [pageNumber]: {
          data,
          next: response.data?.next || null,
          previous: response.data?.previous || null,
          hasMore,
        },
      }));
    } catch (error) {
      console.error("Error loading lead data:", error);
    } finally {
      setLoading(false);
    }
  };

  const path = getBasePathByUserRole()

  const allLeadData = ()=>{
    navigate(`/${path}/lead/reassign` ,{
      state: { leadSourceId : selectedLeadSourceId ,assignStatus : true , teamId : selectedTeamId, leadCount : totalLeads ,teamStatus : teamStatus},
      })
  }



  const handlePageChange = (token, direction) => {
    handleLoadData(token, direction);
  };


  const handleSourceLead = () => {

    if (!selectedLeadSourceId) {

      return;
    }

    setCurrentPage(1);
    setNextPageToken(null);
    setPrevPageToken(null);
    setCachedPages({});

    handleLoadData(null, null);
  };


  useEffect(() => {
    setCurrentPage(1);

    if (selectedLeadSourceId) {
      handleLoadData();
    }
  }, [selectedLeadStatusId]);

  return (
    <div className="bg-appGrayBackground">
       <AdminAppBar />
      <div className="h-full py-20">
        <div className="px-8 flex pt-12  justify-between items-center">
<div className="flex items-center ">
<svg
            onClick={() => navigate(-1)}
            className="cursor-pointer relative md:w-5 md:h-7 lg:w-5 lg:h-9"
            width="20"
            height="34"
            viewBox="0 0 22 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
              fill="#399E79"
            />
          </svg>

          <div className="font-semibold md:mx-0 cursor-default text-3xl lg:mx-6 mx-14">
            { teamStatus ? "Unassigned Fresh With Team" : "Unassigned Fresh Without Team" } 
          </div>
</div>

         { totalLeads > 1 && (
           <button
           className={`border-2 ${
              totalLeads === 0
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-customGreen cursor-pointer"
            } text-white w-40 text-base  mr-12 font-semibold px-2 py-2 rounded-md transition-colors`}
                        disabled={totalLeads === 0}
            onClick={allLeadData}
          >
            Assign All Leads
          </button>
         )}
        </div>
        <div className="flex gap-16 px-20 mt-6">
          <div className="w-1/2 bg-white h-64 p-4 rounded-md">
            <div className="flex flex-col gap-5">
              <label
                className="text-2xl xl:text-xl font-bold"
                htmlFor="lead-source"
              >
                Lead Source
              </label>
              <div className="flex w-full">
                <Select
                  options={leadSources.map((source) => ({
                    value: source.id,
                    label: source.name,
                  }))}
                  onChange={handleLeadSourceChange}
                  value={selectedLeadSource}
                  placeholder="Select Lead Source"
                  isClearable
                  isSearchable
                  className="w-full focus:outline-none focus:shadow-outline"
                />
              </div>

{
  teamStatus && (
    <>
                  <label
                className="text-2xl xl:text-xl font-bold"
                htmlFor="lead-source"
              >
                Team 
              </label>
              <div className="flex w-full">
                <Select
                  options={team.map((source) => ({
                    value: source.teamId,
                    label: source.name,
                  }))}
                  onChange={handleTeamChange}
                  value={selectedTeam}
                  placeholder="Select Team..."
                  isClearable
                  isSearchable
                  className="w-full focus:outline-none focus:shadow-outline"
                />
              </div>
    </>
  )
}
<div className="flex justify-center">
    <button
      className={`border-2 w-28 text-white text-base mt-16 font-semibold px-2 py-2 rounded-md transition-colors
        ${isDisabled ? "bg-gray-400 cursor-not-allowed" : "bg-customGreen cursor-pointer"}`}
      disabled={isDisabled}
      onClick={handleSourceLead}
    >
      Apply
    </button>
  </div>
            </div>
            
          </div>

          <div className="w-1/2 bg-white shadow-md p-2 rounded-md py-3">
            <AllLeadFilter
              selectedTeam={leads}
              totalLeadCount={totalLeads}
              displayStatus={true}
              allLeadData={allLeadData}
              nextPageToken={nextPageToken}
              prevPageToken={prevPageToken}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              onStatusChange={handleStatusChange}
              selectedStatus={selectedStatus}
              emptyError={"select lead source"}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnassignedLead;